import { Card, Box } from '@mui/material';
import { WsTypography, WsTypoVariants, WsTypoColors } from 'wisestep-base';

const OrganizationalUnitDescriptionTab = ({ ouDescription }) => (
  <Card sx={{ minHeight: 300, alignItems: 'center', width: '100%' }}>
    <Box textAlign="left" px={4}>
      <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.SECONDARY}>
        {
          <div
            dangerouslySetInnerHTML={{
              __html: `<div style="margin:20px;">${ouDescription ?? 'No Description added'}</div>`,
            }}
          ></div>
        }
      </WsTypography>
    </Box>
  </Card>
);
export default OrganizationalUnitDescriptionTab;
